// extracted by mini-css-extract-plugin
module.exports = {"related-stories":"relatedStories-m__related-stories__5x_Dd"};